export const formatBrandCuisineLine = (cuisine) => {
  if (cuisine == null) return null;
  if (Array.isArray(cuisine)) {
    const parts = cuisine
      .map((c) => (c != null ? String(c).trim() : ""))
      .filter(Boolean);
    return parts.length ? parts.join(" · ") : null;
  }
  const s = String(cuisine).trim();
  return s || null;
};
